<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="franchiseGroups"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-franchise-group") }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'franchiseGroups'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-franchise-group
      :modelDialog="franchiseGroupDialog"
      @close="franchiseGroupDialog = false"
    ></add-edit-franchise-group>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import paginate from "@/mixins/paginations";
import AddEditFranchiseGroup from "./admin/AddEditFranchiseGroup.vue";
import { mapState } from "vuex";

export default {
  name: "FranchiseGroupAdmin",
  components: {
    AddEditFranchiseGroup,
    PaginationDynamic
  },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      franchiseGroupDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      franchiseGroups: (state) => state.franchiseGroups.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.franchiseGroups.editedId
    }),
    pageCount() {
      return Math.ceil(this.franchiseGroups.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "franchiseGroups");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "franchiseGroups");
    },
    openDialog() {
      this.$store.commit("franchiseGroups/setEditedId", -1);
      this.$store.commit(
        "franchiseGroups/setEditedItem",
        Object.assign({}, {})
      );
      this.franchiseGroupDialog = true;
    },
    editItem(item) {
      this.$store.commit("franchiseGroups/setEditedId", item.id);
      this.$store.commit(
        "franchiseGroups/setEditedItem",
        Object.assign({}, item)
      );
      this.franchiseGroupDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.franchise-group"))) {
        this.$store
          .dispatch("franchiseGroups/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.franchise-group-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "franchiseGroups");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.franchise-group-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
